<template>
  <span>
    <Button
      icon="pi pi-calendar"
      class="p-button-rounded p-button-info p-mr-2"
      @click="showModal()"
      v-tooltip.top="title"
    />
    <Dialog
      :visible.sync="dialog"
      :style="{ width: '540px' }"
      :header="title"
      :modal="true"
    >
      <div class="p-fluid">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <form
            class="text-left"
            role="registerForm"
            @submit.prevent="handleSubmit(confirmMeeting)"
          >
            <base-input
              v-model="innerValue.meeting_link"
              rules="required|min:8"
              label="Enlace"
              name="Enlace"
              type="text"
            />
            <base-input
              v-model="innerValue.meeting_duration"
              rules="required|min_value:10"
              label="Duración (En minutos)"
              name="Duración"
              type="number"
            />
            <base-input
              v-model="innerValue.meeting_start_date"
              label="Fecha Inicio"
              name="Fecha Inicio"
              type="datetime-local"
              :min="minDate"
            />
            <input type="hidden" id="timezone" name="timezone" value="-08:00" />
            <div class="p-d-flex p-pt-3">
              <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text mx-2"
                @click="dialog = false"
              />
              <Button
                class="mx-2"
                label="Guardar"
                icon="pi pi-check"
                type="submit"
              />
            </div>
          </form>
        </ValidationObserver>
      </div>
    </Dialog>
  </span>
</template>

<script>
import { mapActions } from "vuex";
import Meeting from "@/models/meeting.model";
import meetingService from "@/services/axios/meetings.service";
export default {
  props: {
    lessonId: {
      type: Number,
      required: true
    },
    meeting: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.innerValue = new Meeting(this.meeting);
  },
  watch: {
    meeting(newVal) {
      this.innerValue = new Meeting(newVal);
    }
  },
  data() {
    return {
      dialog: false,
      innerValue: new Meeting(),
      minDate: new Date().toISOString().slice(0, 16)
    };
  },
  computed: {
    title() {
      return this.innerValue.meeting_id === 0
        ? "Agendar Reunión"
        : "Actualizar Reunión";
    },
    month() {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octobre",
        "Noviembre",
        "Deciembre",
      ];
      return months[new Date(this.innerValue.meeting_start_date).getMonth()];
    }
  },
  methods: {
    ...mapActions(["getModuleEvents"]),
    showModal() {
      this.dialog = true;
    },
    confirmMeeting() {
      const meetingDate = new Date(this.innerValue.meeting_start_date);
      const year = meetingDate.getFullYear();
      const date = meetingDate.getDate();
      const hours = meetingDate.getHours();
      const minutes = meetingDate.getMinutes();
      const fullDate = `${date} de ${this.month} del ${year} a las ${hours}:${minutes}`;
      this.$confirm.require({
        message: `¿Estás seguro de agendar una reunión para el día ${fullDate}?`,
        header: "Agendar Reunión",
        icon: "pi pi-calednar",
        acceptLabel: "Si",
        acceptClass: "p-button-success",
        accept: () => this.saveMeeting(),
        reject: () => {},
      });
    },
    saveMeeting() {
      meetingService
        .save({
          ...this.innerValue,
          lesson_id: this.lessonId
        })
        .then(
          ({ data }) => {
            this.dialog = false;
            this.getModuleEvents();
            this.$swal({
              text: this.innerValue.meeting_id
                ? "Reunión actualizada con éxito"
                : "Reunión agendada con éxito",
              icon: "success"
            });
            this.innerValue.meeting_id = data;
          },
          (error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.error,
            });
          }
        );
    },
  },
};
</script>

<style>
.p-datepicker-inline {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/Leccion/ScheduleMeeting.vue